import { render, staticRenderFns } from "./CommonPagination.vue?vue&type=template&id=72e637c0&lang=html&"
import script from "./CommonPagination.vue?vue&type=script&lang=ts&"
export * from "./CommonPagination.vue?vue&type=script&lang=ts&"
import style0 from "./CommonPagination.vue?vue&type=style&index=0&id=72e637c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports